import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {stepOptions} from "../../flowManager/StepOptions";
import {logout} from "@arboxappv4/shared/src/redux/authSlice";
import {useSearchParams} from "react-router-dom";

const useKiosk = () => {
    const currStep = useSelector(state => state.stepper.currStep)
    const flowRes = useSelector(state => state.stepper.flowRes)
    const loggedIn = useSelector(state => state.auth.loggedIn)
    const dispatch = useDispatch()
    const [searchParams] = useSearchParams();
    const params = useMemo(() => Object.fromEntries([...searchParams]), [searchParams]);

    const isKiosk = useMemo(() => params.kiosk === 'true', [params]);

    useEffect(() => {
        if(isKiosk) {
            console.log('kiosk currStep', currStep)
            if (currStep === stepOptions.SUCCESS) { //if we are on success step, refresh the page (if it's still on success step)
                resetFlow(5000, stepOptions.SUCCESS)
            }
            if (currStep === stepOptions.PAYMENT) { //if we are at payment step and 5 minutes have passed (and the step is still payments), refresh the page
                setTimeout(() => {
                    if(currStep === stepOptions.PAYMENT) {
                        resetFlow() // we need to logout only after 5 minutes have passed so we'll call resetFlow in a separate setTimeout
                    }
                }, 300000)
            }
        }
    }, [currStep, isKiosk]);

    useEffect(() => {
        if(isKiosk && flowRes?.showSuccessToast) {
            resetFlow(1000)
        }
    }, [flowRes, isKiosk]);

    useEffect(() => {
        if(isKiosk && loggedIn) {
            setTimeout(() => {
                dispatch(logout())
                window.location.reload()
            }, 600000)
        }
    }, [loggedIn, isKiosk]);

    const resetFlow = (time = 10, stepToCompare = null) => {
        dispatch(logout()) //TODO: THIS WILL BE A PROBLEM ON STEP 2 (LOG OUT IS RELOADING)
        setTimeout(() => {
            if(!stepToCompare || (currStep === stepToCompare)) window.location.reload()
        }, time)
    }
};

export default useKiosk;